const MAX_LENGTH_FIELD = 256
const MAX_LENGTH_DESCRIPTION = 10000
const MAX_LENGTH_PASSWORD = 32

export { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, MAX_LENGTH_PASSWORD }
